import { periodFormat } from 'utils/common';

export const ApplicationsReq = filter => {
  const REQ_BODY = {
    filters: {
      search: filter.search ? filter.search : '*',
      protocol: filter.protocol[0] ? filter.protocol : '*',
      port: filter.port[0] ? filter.port : '*',
      createdAt: periodFormat(filter.createdAt),
      enabled: filter.enabled ? (filter.enabled === 'Yes' ? true : false) : '*',
      companySize: filter.companySize[0] ? filter.companySize : '*',
      plan: filter.plan[0] ? filter.plan : '*',
      billingCycle: filter.billingCycle[0] ? filter.billingCycle : '*',
      accountManager: filter.accountManager[0] ? filter.accountManager : '*',
      customerSuccessEngineer: filter.customerSuccessEngineer[0]
        ? filter.customerSuccessEngineer
        : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };

  return REQ_BODY;
};

export const parserData = dataFromServer => {
  return {
    page: dataFromServer.page,
    totalPages: dataFromServer.totalPages,
    totalRecords: dataFromServer.totalRecords,
    data: dataFromServer.data.map(item => ({
      ...item,
      _id: item.appId,
      enabled: item.enabled ? 'Yes' : 'No'
    }))
  };
};
